import FormContext from './context';
import Form from './form';
import Group from './group';
import Item, { FormItemContext } from './item';
import Submit from './submit';
import Reset from './reset';
import './styles/index.scss';
const ExpandedForm = Form;
ExpandedForm.Item = Item;
ExpandedForm.Context = FormContext;
ExpandedForm.Submit = Submit;
ExpandedForm.Reset = Reset;
ExpandedForm.Group = Group;
ExpandedForm.ItemContext = FormItemContext;
const Context = FormContext;
const ItemContext = FormItemContext;
export { Context, Item, ItemContext, Submit };
export default ExpandedForm;
